module.exports = {"511126100":"焉城镇","511126101":"黄土镇","511126102":"甘江镇","511126103":"界牌镇","511126104":"中兴镇","511126105":"三洞镇","511126106":"吴场镇","511126107":"木城镇","511126108":"华头镇","511126109":"甘霖镇","511126110":"新场镇","511126200":"顺河乡","511126201":"马村乡","511126202":"土门乡","511126203":"青州乡","511126204":"梧凤乡","511126205":"永青乡","511126206":"迎江乡","511126207":"龙沱乡","511126208":"南安乡","511126209":"歇马乡","511126210":"麻柳乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511126.json
// module id = 2152
// module chunks = 0